import gql from 'graphql-tag';

export const CROP_NAMES_QUERY = gql`
  query CropNames {
    crops(
      filters: [{ name: "crop.status", operator: "!=", value: "archived" }]
      orderBy: [{ name: "crop.crop_name", direction: "asc" }]
    ) {
      edges {
        node {
          id
          crop_name
          status
        }
      }
    }
  }
`;
